<template>
  <div class="weixin" style="padding-top: 50px;">
    <img src="../../static/image/xiaochengxu_title.png" class="fullWidth" />
    <!-- <img src="../../static/image/xiaochengxu_con.png" class="fullWidth" /> -->
    <div class="xcx">
      <p class="xcxnb">小程序</p>
      <p class="xcxjj">
        小程序是微信里的APP，但它不占用内存，不会对您的手机带来负担。它
        是一种不需要下载，随时可用，用完就走的轻型应用工具。它是目前市面上获得
        微信流量成本最低的应用，无论什么行业的商家或企业，都需要借助它来布局未来流量。
      </p>
      <Row class="xcxpci">
        <Col span="12">
          <img style="width:100%;" src="../../static/llog/bg2.png" alt />
        </Col>
        <Col class="xcx-text" span="12">
          <p class="xcxp">
            <span class="chushou">触手可及 ——</span>
            <span>扫一扫或者搜一下就可打开</span>
          </p>
          <p class="xcxp">
            <span class="chushou">用完即走 ——</span>
            <span>随时可用，无需安装或卸载</span>
          </p>
          <p class="xcxp">
            <span class="chushou">丰富的组件——</span>
            <span>满足不同的功能及开发需求</span>
          </p>
          <p class="xcxp">
            <span class="chushou">附近的小程序 ——</span>
            <span>从线上引流到线下门店</span>
          </p>
          <p class="xcxp">
            <span class="chushou">关联公众号 ——</span>
            <span>公众号和小程序可互相跳转</span>
          </p>
          <p class="xcxp">
            <span class="chushou">众多流量入口 ——</span>
            <span>增加了消费者与品牌的粘性</span>
          </p>
          <p class="xcxp">
            <span class="chushou">轻推广模式 ——</span>
            <span>次锁定客户，多次收益</span>
          </p>
        </Col>
      </Row>
    </div>
    <div style="background: #f0f3f6">
      <div style="height: 90px;"></div>
      <div class="font36 fontfaYahei color33 alignCenter">为何要做小程序</div>
      <div style="height: 90px;"></div>
      <Row type="flex" justify="center" class="code-row-bg">
        <Col span="16">
          <Row>
            <!-- <Col span="6" v-for="(item,index) in whyList" :key="index">
              <div>
                <img :src="item.icon" style="width: 90%" class="centerLR" />
              </div>
            </Col>-->
            <Col span="6">
              <div class="xbg">
                <p class="alignCenter">
                  <img class="imgtop" src="../../static/llog/icon.png" alt />
                </p>
                <p class="alignCenter mdn">行业热词等你抢占</p>
                <p class="md">越早上线小程序即可优先注册优 秀行业热词、避免同行抢占</p>
              </div>
            </Col>
            <Col span="6">
              <div class="xbg">
                <p class="alignCenter">
                  <img class="imgtop" src="../../static/llog/icon1.png" alt />
                </p>
                <p class="alignCenter mdn">无需下载更多流量</p>
                <p class="md">有微信即可快速进入小程序，一站 式快速购物、带来更多流量</p>
              </div>
            </Col>
            <Col span="6">
              <div class="xbg">
                <p class="alignCenter">
                  <img class="imgtop" src="../../static/llog/icon2.png" alt />
                </p>
                <p class="alignCenter mdn">降低门槛快速创业</p>
                <p class="md">为更多个人和小型企业降低创业门 槛、更快的入驻移动电商</p>
              </div>
            </Col>
            <Col span="6">
              <div class="xbg">
                <p class="alignCenter">
                  <img class="imgtop" src="../../static/llog/icon3.png" alt />
                </p>
                <p class="alignCenter mdn">安全稳定官方平台</p>
                <p class="md">依托微信官方平台、用户资金有安 全保证、接口更加稳定</p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div style="height: 90px;"></div>
    </div>
    <div style="height: 90px;"></div>
    <div class="font36 fontfaYahei color33 alignCenter">小程序应用场景</div>
    <div style="height: 90px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <Row>
          <Col span="6" v-for="(item,index) in changjingList" :key="index">
            <div
              style="height:252px;"
              :class="{borderRNo:item.right,borderTNo:item.top,borderCC:item.border,borderTRNo:item.tr,borderLTNo:item.lt}"
            >
              <table class="fullWidth" style="height: 252px">
                <div>
                  <img class="centerLR" :src="item.icon" style="width: 38px;" />
                </div>
                <div
                  class="fontfaYahei font18 color33 centerLR"
                  style="margin-top:35px"
                >{{item.name}}</div>
                <div style="height: 20px;"></div>
                <div class="fontfaYahei font12 color99 wxnb">{{item.subname1}}{{item.subname2}}</div>
              </table>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
    <div style="height: 90px;"></div>
    <xfck></xfck>
  </div>
</template>

<script>
import $ from "jquery";
import xfck from "./xfck.vue";

var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "/jianyunPC";
// }
export default {
  name: "weixin",
  data() {
    return {
      windowHeight: $(window).width() / 6 + "px",
      whyList: [
        { icon: img_url_i + "/static/image/xiaochengxu_c1.png" },
        { icon: img_url_i + "/static/image/xiaochengxu_c2.png" },
        { icon: img_url_i + "/static/image/xiaochengxu_c3.png" },
        { icon: img_url_i + "/static/image/xiaochengxu_c4.png" }
      ],
      changjingList: [
        {
          name: "线下扫码",
          icon: img_url_i + "/static/image/cx1.png",
          subname1: "扫描小程序二维码，无需下载",
          subname2: "快速购物",
          top: false,
          right: true,
          border: false,
          tr: false,
          lt: false
        },
        {
          name: "搜索查找",
          icon: img_url_i + "/static/image/cx2.png",
          subname1: "在“小程序”中搜索你的",
          subname2: "小程序",
          top: false,
          right: true,
          border: false,
          tr: false,
          lt: false
        },
        {
          name: "公众号关联",
          icon: img_url_i + "/static/image/cx3.png",
          subname1: "在公众号关联小程序，",
          subname2: "快速引流",
          top: false,
          right: true,
          border: false,
          tr: false,
          lt: false
        },
        {
          name: "对话分享",
          icon: img_url_i + "/static/image/cx4.png",
          subname1: "推荐小程序给微信好友，",
          subname2: "增加线上成交率",
          top: false,
          right: false,
          border: true,
          tr: false,
          lt: false
        },
        {
          name: "分享到微信群",
          icon: img_url_i + "/static/image/cx5.png",
          subname1: "分享小程序到微信群，批量",
          subname2: "增加平台流量",
          top: false,
          right: false,
          border: false,
          tr: true,
          lt: false
        },
        {
          name: "历史列表",
          icon: img_url_i + "/static/image/cx6.png",
          subname1: "使用过的小程序会被列入用户的",
          subname2: "历史列表、方便下次使用",
          top: false,
          right: false,
          border: false,
          tr: true,
          lt: false
        },
        {
          name: "附近小程序",
          icon: img_url_i + "/static/image/cx7.png",
          subname1: "企业资质设置门店位置",
          subname2: "可搜索附近5公里内小程序",
          top: false,
          right: false,
          border: false,
          tr: true,
          lt: false
        },
        {
          name: "收藏夹",
          icon: img_url_i + "/static/image/cx8.png",
          subname1: "收藏经常使用的小程序，再也不怕",
          subname2: "被其它无用的小程序覆盖了",
          top: false,
          right: false,
          border: false,
          tr: false,
          lt: true
        }
      ]
    };
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mdn {
  margin: 20px 0;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.md {
  width: 150px;
  margin-left: 45px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
}
.imgtop {
  margin-top: 45px;
}
.xbg {
  width: 230px;
  height: 320px;
  background-color: white;
}
.xcxp {
  margin-top: 5px;
}
.xcx-text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #999999;
}
.xcxpci {
  margin-top: 60px;
}
.xcxnb {
  text-align: center;
  margin-top: 70px;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.xcxjj {
  margin-top: 60px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}
.chushou {
  height: 14px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #fd7b35;
}
.xcx {
  width: 680px;
  height: 500px;
  margin: 0 auto;
}
.wxnb {
  margin-left: 50px;
  margin-right: 50px;
}
.namenb {
  margin-left: 50px;
  margin-right: 50px;
}
.centerLR {
  margin-top: 45px;
}
.imgname {
  margin-left: 50px;
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/weixin.vue